import accountRoutes from "./account";
import commonRoutes from "./common";
import invoicemoreRoutes from "./invoicemore";
import loginRoutes from "./login";
import payoutmoreRoutes from "./payoutmore";
import testRoutes from "./test";

export {
  accountRoutes,
  commonRoutes,
  invoicemoreRoutes,
  loginRoutes,
  payoutmoreRoutes,
  testRoutes,
};
